import { useState } from "react";

import { ConfirmActionModal, Switch } from "~/common/components";
import {
  useActivateInvitationLink,
  useDeactivateInvitationLink,
} from "~/providers/hooks/queries/useInvitationLinks";
import { ConsultationLinkResponse } from "~/providers/types/invitations";

interface ActivateDeactivateConsultationLinkModalProps {
  link: ConsultationLinkResponse;
}

export const ActivateDeactivateConsultationLinkModal = ({
  link,
}: ActivateDeactivateConsultationLinkModalProps) => {
  const [showActivate, setShowActivate] = useState(false);
  const [showDeactivate, setShowDeactivate] = useState(false);
  const isActive = link.is_active;

  const {
    mutate: activateInvitationLinkMutation,
    isPending: isActiveConsultationLinkPending,
  } = useActivateInvitationLink(() => setShowActivate(false));

  const {
    mutate: deactivateInvitationLinkMutation,
    isPending: isDeactivateConsultationLinkPending,
  } = useDeactivateInvitationLink(() => setShowDeactivate(false));

  return (
    <div>
      <Switch
        defaultChecked={isActive}
        checked={isActive}
        onClick={() =>
          isActive ? setShowDeactivate(true) : setShowActivate(true)
        }
        className="flex-row-reverse text-sm"
      >
        Link Active
      </Switch>
      <ConfirmActionModal
        show={showActivate}
        isLoading={isActiveConsultationLinkPending}
        onConfirm={() => activateInvitationLinkMutation(link.id)}
        onClose={() => setShowActivate(false)}
        title="Activate link"
        description="Prospective patients will be able to request a consultation via the QR code or URL for this link."
        confirmButtonText="Activate link"
        titleClassName="text-2xl"
      />
      <ConfirmActionModal
        show={showDeactivate}
        isLoading={isDeactivateConsultationLinkPending}
        onConfirm={() => deactivateInvitationLinkMutation(link.id)}
        onClose={() => setShowDeactivate(false)}
        title="Deactivate link"
        description="While deactivated, prospective patients will not be able to request a consultation via the QR code or URL for this link."
        confirmButtonText="Deactivate link"
        titleClassName="text-2xl"
      >
        <p className="leading-5 text-gray-70">
          Are you sure you want to deactivate this link?
        </p>
      </ConfirmActionModal>
    </div>
  );
};
